import { render } from "./VsudBadge.vue?vue&type=template&id=1965d94d"
import script from "./VsudBadge.vue?vue&type=script&lang=js"
export * from "./VsudBadge.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__